import {OnboardingStyle} from "@components/onboarding/onboarding.style";
import {createStyles, Theme} from "@material-ui/core";

export const SubscribeStyles = (theme: Theme) => createStyles({
    ...OnboardingStyle(theme),
    middleContent: {
        ...OnboardingStyle(theme).middleContent,
        margin: 0,
        gap: theme.spacing(5),
    },
    featuresList: {
        listStyleType: 'none',
        margin: 0,
        padding: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1),

        '& li': {
            display: 'flex',
            flexDirection: 'row',
            gap: theme.spacing(1),
            alignItems: 'center',
            justifyContent: 'flex-start',
        }
    },
});



// WEBPACK FOOTER //
// ./src/components/onboarding/steps/StepSubscribe/subscribe.styles.ts